<div class="container common-container-padding">
  <div class="line-heading">Overall GWP growth % by month</div>
  <div class="title-text">compare to last year</div>

  <div
    class="cust-padding cust-padding-desktop"
    style="position: relative"
    id="chartLine"
  >
    <div class="mobile-width mobile-scroll">
      <!-- style="overflow-x: scroll;" -->
      <div class="mob-width">
        <canvas [id]="chartId" height="300" width="600"></canvas>
      </div>

      @if (!getDesktopView()) {
        <canvas id="yAxisLabels" height="300" width="0"> </canvas>
      }
      @if (!getDesktopView()) {
        <canvas id="yAxisMobileView" height="300" width="0"> </canvas>
      }

      @if (!getDesktopView()) {
        <span class="swiper-text lbl">Swipe to view more</span>
      }
    </div>
  </div>

  <!-- <div *ngIf="getDesktopView()">
    <div class="line-chart-container cust-padding-desktop">
      <canvas [id]="chartId" class="line-chart"></canvas>
    </div>
  </div> -->
  @if (!showChart) {
    <div nxRow style="justify-content: center">
      <div nxCol="12,12,12,4">
        <div class="line-heading cust-space-top">No previous year data</div>
      </div>
    </div>
  }
  <div nxRow>
    <div class="line-legend-container" nxCol="12,12,12,4">
      <div id="line-legend"></div>
    </div>
  </div>
</div>
